import React from "react"
import { StoreApi } from "zustand"

export const createZustandContext = <TInitial, TState>(
  getStore: (initial: TInitial) => StoreApi<TState>,
) => {
  const Context = React.createContext<StoreApi<TState> | null>(null)

  const Provider = (props: {
    children?: React.ReactNode
    initialValue: TInitial
  }) => {
    const [store] = React.useState(() => getStore(props.initialValue))

    return <Context.Provider value={store}>{props.children}</Context.Provider>
  }

  return {
    useContext: () => React.useContext(Context),
    Context,
    Provider,
  }
}
